import ResultChoice from './resultChoice.js';
export default ResultChoice;
